export const KenoSoundsName = {
  bet: 'bet',
  selection: 'selection',
  clear: 'clear',
  matching: 'matching',
  noMatching: 'noMatching',
  win: 'win',
};

export const KenoSoundsPath = [
  {
    src: 'audio/keno/clear.mp3',
    name: KenoSoundsName.clear,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/keno/matching.mp3',
    name: KenoSoundsName.matching,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/keno/nomatching.mp3',
    name: KenoSoundsName.noMatching,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/keno/win.mp3',
    name: KenoSoundsName.win,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/keno/selection.mp3',
    name: KenoSoundsName.selection,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/keno/bet.mp3',
    name: KenoSoundsName.bet,
    autoplay: false,
    html5: true,
  },
];
